import React from 'react'
import type { ContextValue } from './types'

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const Context = React.createContext<ContextValue<any>>(null as any)

export type { ContextValue }
